module.exports = __webpack_public_path__ + "static/media/team-rocket-max.ed9816b7.wav";